export default __webpack_public_path__ + "static/media/image-ph-health-alarm-m@3x.710abb5f.png";